import React from 'react';

const MatchingEngine = ({ selectedMatch }) => {
  if (!selectedMatch) return null;

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="bg-gray-50 border-b p-3">
        <h3 className="font-semibold text-gray-700">AI MATCHING INSIGHTS</h3>
      </div>
      
      <div className="p-4">
        <div className="flex flex-col md:flex-row items-start md:items-center mb-6">
          <div className="flex items-center mb-4 md:mb-0 md:mr-8">
            <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
              <img 
                src={selectedMatch.client.image} 
                alt={selectedMatch.client.name} 
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h4 className="font-medium text-gray-800">{selectedMatch.client.name}</h4>
              <p className="text-gray-500 text-sm">Client since {selectedMatch.client.clientSince}</p>
            </div>
          </div>

          <div className={`flex items-center justify-center w-16 h-16 rounded-full ${selectedMatch.compatibilityScore >= 90 ? 'bg-green-100' : selectedMatch.compatibilityScore >= 80 ? 'bg-blue-100' : 'bg-yellow-100'} mx-4`}>
            <span className="font-bold text-lg">{selectedMatch.compatibilityScore}</span>
          </div>

          <div className="flex items-center mt-4 md:mt-0">
            <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
              <img 
                src={selectedMatch.advisor.image} 
                alt={selectedMatch.advisor.name} 
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h4 className="font-medium text-gray-800">{selectedMatch.advisor.name}</h4>
              <p className="text-gray-500 text-sm">{selectedMatch.advisor.experience} experience</p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h4 className="font-medium text-gray-800 mb-3">AI-Identified Compatibility Factors</h4>
          <div className="space-y-4">
            {selectedMatch.expertiseAreas.map((area, idx) => (
              <div key={idx} className="mb-3">
                <div className="flex justify-between text-sm mb-1">
                  <span>{area.name}</span>
                  <span className="font-medium">{area.score}%</span>
                </div>
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div 
                    className={`h-full rounded-full ${
                      area.score >= 90 ? 'bg-green-500' : 
                      area.score >= 80 ? 'bg-blue-500' : 'bg-yellow-500'
                    }`}
                    style={{ width: `${area.score}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <h4 className="font-medium text-gray-800 mb-3">Performance Metrics</h4>
          <div className="grid grid-cols-2 gap-4">
            <div className="border rounded-lg p-3">
              <p className="text-sm text-gray-500">Client Retention</p>
              <p className="font-medium text-lg">{selectedMatch.relationshipMetrics.retention}%</p>
              <div className="h-1.5 bg-gray-200 rounded-full mt-1 overflow-hidden">
                <div 
                  className="h-full bg-green-500 rounded-full" 
                  style={{ width: `${selectedMatch.relationshipMetrics.retention}%` }}
                ></div>
              </div>
            </div>
            <div className="border rounded-lg p-3">
              <p className="text-sm text-gray-500">Portfolio Growth</p>
              <p className="font-medium text-lg">{selectedMatch.relationshipMetrics.growth}%</p>
              <div className="h-1.5 bg-gray-200 rounded-full mt-1 overflow-hidden">
                <div 
                  className="h-full bg-blue-500 rounded-full" 
                  style={{ width: `${(selectedMatch.relationshipMetrics.growth / 20) * 100}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 rounded-lg p-3">
          <h4 className="font-medium text-primaryDark mb-2">AI Recommendation</h4>
          <p className="text-sm text-primaryDark">
            Based on historical performance data and behavioral analysis, this client-advisor pairing 
            has a <span className="font-semibold">{selectedMatch.compatibilityScore}%</span> predicted success rate. 
            The advisor's expertise in {selectedMatch.expertiseAreas[0].name.toLowerCase()} 
            aligns perfectly with the client's primary financial goals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MatchingEngine;